import { useThrottleFn } from '@vueuse/core';
import type { Api } from '@/typings/api';
import { request } from '../request';

/** get constant routes */
export function fetchGetConstantRoutes() {
  return request<Api.Route.MenuRoute[]>({ url: '/route/getConstantRoutes' });
}

/** get user routes */
export const fetchGetUserRoutes = useThrottleFn(() => {
  return request<Api.Route.UserRoute>({ url: '/auth/getRoutes' });
}, 5000);

/**
 * whether the route is exist
 *
 * @param routeName route name
 */
export function fetchIsRouteExist(routeName: string) {
  return request<boolean>({ url: '/route/isRouteExist', params: { routeName } });
}
